module.exports = __webpack_public_path__ + "img/finding-the-key.b9d177e0.jpg";